import { PagedRequest } from './paged-request';

export class ProviderSearchRequest extends PagedRequest {
    public firstName: string;
    public lastName: string;
    public groupName: string;
    public tin: string;
}
